import { render, staticRenderFns } from "./addTalentDrawer.vue?vue&type=template&id=fbd4e822&scoped=true"
import script from "./addTalentDrawer.vue?vue&type=script&lang=js"
export * from "./addTalentDrawer.vue?vue&type=script&lang=js"
import style0 from "./addTalentDrawer.vue?vue&type=style&index=0&id=fbd4e822&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd4e822",
  null
  
)

export default component.exports